import { useDeviceActionSequenceStore } from '@/app/pages/DeviceManagement/deviceActionSequenceStore'
import type { SequenceStarter } from '@/lib/useSequence'
import { useMemo } from 'react'

const DEVICE_ACTION_CONTINUATIONS = new Set(['f', 'c', 'g', 'm', 's'])

/**
 * `U then <key>`: runs a device action (Update Firmware, Update Config, Update Geofence, Update
 * Metadata, Send File) on the current selection, else the hovered row. Unlike `G`/`S`, `U` only arms
 * on the Device Management page — the host includes this starter in its array only while there.
 */
export function useDeviceActionStarter(): SequenceStarter {
	const request = useDeviceActionSequenceStore(s => s.request)

	return useMemo(
		() => ({
			key: 'u',
			continuations: DEVICE_ACTION_CONTINUATIONS,
			onComplete: key => request(key as 'f' | 'c' | 'g' | 'm' | 's'),
		}),
		[request],
	)
}
